<div class="page">
    <h1>Redirecting after signin ... Please Wait</h1>
    <a [href]="mainUrl" color="primary">
        Continue to Site
    </a>
</div>